import { createActionGroup, emptyProps, props } from '@ngrx/store'

import { AiAgent, AiPlan, Message } from '@flowx/designer/modules/new-ai/common/ai.dictionary'

export const AiCoordinatorActions = createActionGroup({
  source: 'AiCoordinator',
  events: {
    introMessage: emptyProps(),
    getIntro: props<{ action_type: string; message: Message; selectedAgent: AiAgent }>(),
    getIntent: props<{
      prompt: string
      location: string
      appId: string
      appVersion: string
      session_id?: string
      generatedIntent?: any
      autonomy_level?: 'low' | 'medium' | 'high'
      recommended_intent?: string
    }>(),
    generatePlan: props<{
      prompt: string
      appId: string
      appVersion: string
      current_plan: AiPlan | null
      context: any
      plan_type: 'agent' | 'application'
      session_id: string
      human_feedback?: string | null
      document_id?: string | null
    }>(),
    getAnswerEventStream: props<{
      response: Partial<Message>
    }>(),
    routeToAgent: emptyProps(),
    routeToAgentConsumed: emptyProps(),
    getIntentSuccess: emptyProps(),
    generateAction: props<{
      action_name: string
      action_parameters: any
    }>(),
    generateActionSuccess: props<{ response_action: any; action_name: string }>(),
    generatePromptForAgent: props<{ agent: any; action_name: string }>(),
    generatePromptForAgentSuccess: props<{ response: any; action_name: string }>(),
    generatePromptForStep: props<{ step: any; agent: AiAgent }>(),
    generateAgentWorkflow: props<{ agent: any }>(),
    generateAgentWorkflowSuccess: props<{ response: any; action_name: string }>(),
    keepAgentDraft: props<{ response: any }>(),
    keepAgentDraftSuccess: props<{ response: any }>(),
    stepInvoked: emptyProps(),
    createPlan: emptyProps(),
    createPlanSuccess: props<{ plan: any }>(),
    getAllPlans: emptyProps(),
    getAllPlansSuccess: props<{ plans: any[] }>(),
    getPlan: props<{ plan_id: string }>(),
    getPlanSuccess: props<{ plan: any }>(),
    updatePlan: props<{ plan_id: string; plan: any; status: string }>(),
    updatePlanSuccess: props<{ plan: any }>(),
    deletePlan: props<{ plan_id: string }>(),
    deletePlanSuccess: emptyProps(),
    selectPlan: props<{ plan_id: string }>(),
    mapDestination: props<{
      current_plan: any
      context: any
      session_id: string
    }>(),
    mapDestinationSuccess: emptyProps(),
  },
})
